module.exports = __webpack_public_path__ + "static/media/bubble-illustration.ebaf6b63.png";